import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ui: {
    loading: false,
    creating: false,
    deleting: false,
    fetchingSingle: false,
    stats: {
      pageCount: 1
    }
  },
  data: [],
  single: null
};

export const recipeGroupsSlice = createSlice({
  name: 'recipeGroups',
  initialState,
  reducers: {
    create_recipe_group: (state) => {
      state.ui.creating = true;
    },
    create_recipe_group_success: (state, { payload }) => {
      state.ui.creating = false;
      state.data.unshift(payload);
    },
    create_recipe_group_error: (state) => {
      state.ui.creating = false;
    },
    get_recipe_group: (state) => {
      state.ui.loading = true;
    },
    get_recipe_group_success: (state, { payload }) => {
      state.ui.loading = false;
      state.data = payload;
    },
    get_recipe_group_error: (state) => {
      state.ui.loading = false;
    },
    remove_recipe_group: (state) => {
      state.ui.deleting = true;
    },
    remove_recipe_group_success: (state, { payload }) => {
      state.ui.deleting = false;
      const response = state.data.filter((data) => data._id !== payload._id);
      state.data = response;
    },
    remove_recipe_group_error: (state) => {
      state.ui.deleting = false;
    },
    update_recipe_group: (state) => {
      state.ui.creating = true;
    },
    update_recipe_group_success: (state, { payload }) => {
      state.ui.creating = false;
      const previousData = state.data;
      const index = previousData.findIndex((data) => data._id === payload._id);
      previousData[index] = payload;
      state.data = previousData;
      if (state.single && state.single._id === payload._id) {
        state.single = payload;
      }
    },
    update_recipe_group_error: (state) => {
      state.ui.creating = false;
    },
    get_single_recipe_group: (state) => {
      state.ui.fetchingSingle = true;
    },
    get_single_recipe_group_success: (state, { payload }) => {
      state.ui.fetchingSingle = false;
      state.single = payload;
    },
    get_single_recipe_group_error: (state) => {
      state.ui.fetchingSingle = false;
    }
  }
});

export const {
  create_recipe_group,
  create_recipe_group_success,
  create_recipe_group_error,
  get_recipe_group,
  get_recipe_group_success,
  get_recipe_group_error,
  remove_recipe_group,
  remove_recipe_group_success,
  remove_recipe_group_error,
  update_recipe_group,
  update_recipe_group_success,
  update_recipe_group_error,
  get_single_recipe_group,
  get_single_recipe_group_success,
  get_single_recipe_group_error
} = recipeGroupsSlice.actions;

export default recipeGroupsSlice.reducer;
